<div *ngIf="events?.length > 0">
  <div class="row text-center">
    <div class="col-md-4">
      <div class="btn-group">
        <div
          class="btn btn-primary"
          mwlCalendarPreviousView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()"
        >
          Previous
        </div>
        <div
          class="btn btn-outline-secondary"
          mwlCalendarToday
          [(viewDate)]="viewDate"
        >
          Today
        </div>
        <div
          class="btn btn-primary"
          mwlCalendarNextView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="closeOpenMonthViewDay()"
        >
          Next
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <h3>{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h3>
    </div>
    <div class="col-md-4">
      <div class="btn-group">
        <div
          class="btn btn-primary"
          (click)="setView(CalendarView.Month)"
          [class.active]="view === CalendarView.Month"
        >
        {{ lang.month }}
        </div>
        <div
          class="btn btn-primary"
          (click)="setView(CalendarView.Week)"
          [class.active]="view === CalendarView.Week"
        >
        {{ lang.week }}
        </div>
        <div
          class="btn btn-primary"
          (click)="setView(CalendarView.Day)"
          [class.active]="view === CalendarView.Day"
        >
        {{ lang.day }}
        </div>
      </div>
    </div>
  </div>
  <br />
  <div [ngSwitch]="view">
    <mwl-calendar-month-view
      *ngSwitchCase="CalendarView.Month"
      [viewDate]="viewDate"
      [events]="events"
      [refresh]="refresh"
      [activeDayIsOpen]="activeDayIsOpen"
      (dayClicked)="dayClicked($event.day)"
      (eventClicked)="handleEvent('Clicked', $event.event)"
    >
    </mwl-calendar-month-view>
    <mwl-calendar-week-view
      *ngSwitchCase="CalendarView.Week"
      [viewDate]="viewDate"
      [events]="events"
      [refresh]="refresh"
      (eventClicked)="handleEvent('Clicked', $event.event)"
    >
    </mwl-calendar-week-view>
    <mwl-calendar-day-view
      *ngSwitchCase="CalendarView.Day"
      [viewDate]="viewDate"
      [events]="events"
      [refresh]="refresh"
      (eventClicked)="handleEvent('Clicked', $event.event)"
    >
    </mwl-calendar-day-view>
  </div>

  <ng-template #modalContent let-link="modalData">
    <div class="modal-header">
      <h4 class="modal-title pull-left">{{modalData.event.title}}</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">

      <!-- <div class="row">
        <div class="col-md-6 text-center">
            <strong>{{ lang.type }}</strong>
        </div>
        <div class="col-md-6">
          {{ modalData.event.meta.type }}    
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 text-center">
            <strong>{{ lang.description }}</strong>
        </div>
        <div class="col-md-6">
          {{ modalData.event.meta.desc }}    
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 text-center">
            <strong>{{ lang.renewalNote }}</strong>
        </div>
        <div class="col-md-6">
          {{ modalData.event.meta.note }}    
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 text-center">
            <strong>{{ lang.created }}</strong>
        </div>
        <div class="col-md-6">
          {{ modalData.event.meta.created }}    
        </div>
      </div> -->


      <div class="row">
        <div class="col-md-6 text-center">
            <strong>{{ lang.description }}</strong>
        </div>
        <div class="col-md-6">
          {{ modalData.event.meta.desc }}    
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 text-center">
            <strong>{{ lang.brand }}</strong>
        </div>
        <div class="col-md-6">
          {{ modalData.event.meta.brand }}    
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 text-center">
            <strong>{{ lang.model }}</strong>
        </div>
        <div class="col-md-6">
          {{ modalData.event.meta.model }}    
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 text-center">
            <strong>{{ lang.matricolaNumber }}</strong>
        </div>
        <div class="col-md-6">
          {{ modalData.event.meta.no_plate }}    
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 text-center">
            <strong>{{ lang.factoryNumber }}</strong>
        </div>
        <div class="col-md-6">
          {{ modalData.event.meta.service_fact }}    
        </div>
      </div>


      <div class="row">
        <div class="col-md-6 text-center">
            <strong>{{ lang.referringPlancode }}</strong>
        </div>
        <div class="col-md-6">
          {{ modalData.event.meta.plan_code }}    
        </div>
      </div>


      <div class="row">
        <div class="col-md-6 text-center">
            <strong>{{ lang.planDescription }}</strong>
        </div>
        <div class="col-md-6">
          {{ modalData.event.meta.plan_description }}    
        </div>
      </div>
      
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="modalRef.hide()">
        OK
      </button>
    </div>
  </ng-template>
</div>